import { ReactElement } from "react";

export default function ContactInfo({ emails, phones, addresses }: GatsbyTypes.strapi_ContactInfo): ReactElement {
    return addresses ? <p>{addresses}</p> : phones ? <a href={"tel:" + phones}>{phones}</a> : emails ? <a href={"mailto: " + emails}>emails</a> : <span></span>;
}
